import React, { useEffect, useState } from "react";
import { Box, Paper } from "@mui/material";
import Header from "../../components/global/Header";
import Table from "../../components/global/TableComponent";
import Popup from "../../components/global/PopUp";
import QueryResponse from "./QueryResponse";
import { HeadCells } from "../../data/QueryData";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import axios from "axios";
import Error404 from "../../pages/Error404";

function Query({ role }) {
  const [openPopup, setOpenPopup] = useState(false);
  const [editId, setEditId] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [queryRecords, setQueryRecords] = useState([]);

  const edit = editId != null;
  const formFieldValues = edit ? editId : null;

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  const fetchFeedbacks = async () => {
    try {
      const response = await fetch(
        "http://localhost:8000/admins/get-all-feedback"
      );
      const data = await response.json();
      const modifiedFeedbacks = data.feedbacks.map((feedback) => ({
        ...feedback,
        id: feedback.query_id,
      }));
      setQueryRecords(modifiedFeedbacks);
    } catch (error) {
      console.error("Error fetching feedback data:", error);
    }
  };

  const deleteRecord = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          console.log(id);
          const response = await axios.delete(
            "http://127.0.0.1:8000/admins/delete-feedback",
            { data: { query_id: id } } // Pass the query_id as part of the data object
          );
          if (response.status === 200) {
            toast.success("Successfully deleted the record");
            fetchFeedbacks();
          } else {
            toast.error("Operation not Completed", response.data);
          }
        } catch (error) {
          toast.error("Operation not Completed");
        }
      }
    });
  };

  const handleAddOrUpdate = async (formData) => {
    const updatedData = {
      ...formFieldValues,
      ...formData,
    };
    try {
      // Make a POST request to the backend endpoint
      const response = await axios.post(
        "http://127.0.0.1:8000/admins/update-status",
        updatedData
      );

      // Handle response based on server's response
      if (response.status === 200) {
        // Handle successful creation of user
        toast.success("Email send successfully", response.data);
        fetchFeedbacks();
        setOpenPopup(false);
      } else {
        toast.error("Failed to send email!!");
      }
    } catch (error) {
      toast.error("Failed to send email!!");
    }
  };

  return (
    <>
      {role === "admin" ? (
        <Box m={"2vw"}>
          <Header title="User Queries" subTitle="List of all user queries" />
          <Paper style={{ background: "#201939eb", padding: "2vh 2vw" }}>
            <Table
              tableHeaders={HeadCells}
              data={queryRecords}
              buttons={[
                { btnName: "Delete", bg: "var(--red)" },
                { btnName: "Response", bg: "var(--color-darkslateblue)" },
              ]}
              addAction={() => setOpenPopup(true)}
              setEditId={setEditId}
              deleteRecord={deleteRecord}
            />
          </Paper>
          <Popup
            title="Query Response"
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
          >
            <QueryResponse
              handleAddOrUpdate={handleAddOrUpdate}
              closePopup={() => setOpenPopup(false)}
            />
          </Popup>
          <Toaster />
        </Box>
      ) : (
        <Error404 />
      )}
    </>
  );
}

export default Query;
